/**
 * Generates a random UUIDv4 string.
 */
export function uuidv4(): string {
  return `${Math.random().toString(36).substring(2, 10)}-${Math.random().toString(36).substring(2, 6)}-${Math.random()
    .toString(36)
    .substring(2, 6)}-${Math.random().toString(36).substring(2, 14)}`;
}

/**
 * Returns a simple hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 */
export function simpleHash(str: string): number {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    let chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
